module.exports = __webpack_public_path__ + "img/56.6a161c72.webp";